module.exports = __webpack_public_path__ + "static/assets/d47cd7e80ff05483811627da0e1739fa.png";